export const environment = {
  production: true,
  apiUrl:'https://api.aureafurniture.com/',
  websiteUrl: 'https://www.aureafurniture.com/#/',
};
